var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content", staticStyle: { "margin-left": "10px" } },
      [
        _c(
          "search-item",
          {
            attrs: {
              "config-module": "101701",
              "show-more-scheme": true,
              "show-simple": _vm.showSimple,
              "expand-adv": true,
              "sim-url": "",
              "adv-url": ""
            },
            on: { query: _vm.toQuery }
          },
          [
            _c(
              "div",
              { attrs: { slot: "operations" }, slot: "operations" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.addHandler } },
                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.editHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger" },
                    on: { click: _vm.removeHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                total: _vm.pageConditions.total,
                page: _vm.pageConditions.pageNum,
                limit: _vm.pageConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.pageConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.pageConditions, "pageSize", $event)
                },
                pagination: _vm.toQuery
              }
            })
          ],
          1
        ),
        _c("form-dialog", {
          attrs: {
            visible: _vm.formDialog.visible,
            "is-edit": _vm.formDialog.isEdit,
            uuid: _vm.formDialog.uuid
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.formDialog, "visible", $event)
            },
            saveCallBack: _vm.saveCallBackHandler,
            close: function($event) {
              _vm.formDialog.visible = false
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }